import { P2 } from '@/lib/shared/components/Typography';
import { SvgInstagram, SvgYoutube, NextArrowIcon } from '@/lib/shared/icons';
import { sendSocialClick } from '@/lib/shared/utils/send-gtm';

import cn from 'clsx';
import Link from 'next/link';

import styles from './Card.module.scss';

interface IProps {
  variant: 'youTube' | 'insta';
  text: string;
  link: string;
}

export const DefaultMediaCard = ({ variant, text, link }: IProps) => {
  const Icon =
    variant === 'insta' ? (
      <SvgInstagram isGradient />
    ) : (
      <SvgYoutube isGradient />
    );

  return (
    <Link
      target={'_blank'}
      href={link}
      className={styles.defaultCard}
      onClick={sendSocialClick}
    >
      <div className={styles.defaultCard__inner}>
        {Icon}
        <div className={styles.defaultCard__bottom}>
          <P2
            className={cn(
              variant === 'insta'
                ? styles.defaultCard__textInsta
                : styles.defaultCard__text
            )}
          >
            {text}
          </P2>
          <div className={styles.defaultCard__arrow}>
            <NextArrowIcon isGradient />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default DefaultMediaCard;
